var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainBannerLayer0101(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{opacity:0.2;}.cls-3{clip-path:url(#clip-path);}.cls-4{opacity:0.3;}.cls-5,.cls-6{fill:#006380;}.cls-5{opacity:0.5;}.cls-7{fill:#809671;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "30.77 16.81 7.57 -5.9 -11.92 13.92 11.28 36.63 30.77 16.81"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M7.35,23.34,5.82,24.9h0l-2.08-.54v0l-.57-2.08L4.66,20.7h0l2.09.54v0ZM5.79,24.8l1.46-1.48-.56-2-2-.52L3.23,22.28l.55,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M11.1,19,9.87,20.24h0L8.19,19.8v0l-.46-1.66,1.22-1.24H9l1.67.44v0ZM9.85,20.16,11,19l-.45-1.61L9,17,7.8,18.14l.44,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M11.81,24.78l-1.3,1.32h0l-1.76-.46v0l-.48-1.75,1.29-1.32h0l1.77.45v0ZM10.49,26l1.23-1.25-.46-1.69-1.71-.45L8.32,23.88l.47,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M13.74,21.73l-.72.74h0l-1-.25h0l-.27-1,.72-.73h0l1,.26h0Zm-.73.69.68-.7-.26-.94-.94-.24-.69.69.26.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M13.09,18.58l-.72.73h0l-1-.25h0l-.27-1,.72-.73h0l1,.26h0Zm-.73.69.68-.7-.26-.94-.94-.25-.69.7.26.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8.8,14.76l-.8.81H8l-1.1-.28v0l-.3-1.09.8-.81h0l1.1.29h0ZM8,15.52l.76-.77-.29-1.06L7.4,13.42l-.76.78.29,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2.06,16.61l-.45.45h0L1,16.9H1l-.17-.61.45-.46h0l.61.16h0ZM1.6,17,2,16.6,1.87,16l-.59-.15-.43.43.16.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1.2,21.67l-.64.65h0l-.87-.23h0l-.24-.87.64-.66h0l.88.22H1Zm-.65.61.61-.63-.23-.84-.84-.22-.62.63.24.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1.54,25.12l-.7.71h0l-1-.25h0l-.26-.95.7-.71h0l1,.25h0Zm-.71.67.67-.68-.26-.92L.32,24l-.67.68.26.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M6.28,17.76l-1,1.07h0l-1.44-.37v0L3.37,17l1.06-1.07h0l1.44.37v0Zm-1.07,1,1-1-.39-1.38L4.45,16l-1,1,.38,1.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "3.22 22.3 1.16 21.68 1.17 21.63 3.23 22.25 3.22 22.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "3.42 17.03 2.02 16.61 2.03 16.57 3.43 16.99 3.42 17.03"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 6.37,
    y: 20.52,
    width: 2.16,
    height: 0.06,
    transform: "translate(-12.42 11.45) rotate(-45.48)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "6.64 26.7 6.59 26.72 5.77 24.81 5.82 24.79 6.64 26.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "7.79 18.17 6.24 17.78 6.25 17.72 7.8 18.11 7.79 18.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 5.61,
    y: 15.77,
    width: 1.53,
    height: 0.06,
    transform: "translate(-9.36 9.26) rotate(-45.48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M.37,9.61-.85,10.86h0l-1.67-.43v0L-3,8.74-1.78,7.5h0l1.67.43V8ZM-.87,10.78.29,9.59-.15,8l-1.61-.42L-2.93,8.76l.45,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1.08,15.4-.21,16.71h0L-2,16.25v0l-.49-1.76,1.3-1.31h0l1.76.46v0ZM-.23,16.63,1,15.38l-.47-1.7-1.7-.44L-2.4,14.5l.47,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1.59,19.16l-.74.76h0l-1-.27h0l-.28-1,.74-.76h0l1,.26h0Zm-.75.71.71-.72-.27-1-1-.25-.71.72.27,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3,12.35l-.72.73h0l-1-.25h0l-.27-1,.72-.73h0l1,.26h0ZM2.28,13l.69-.7-.26-.94-.95-.25-.68.7.26.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2.36,9.2l-.71.73h0l-1-.25v0l-.27-1L1.1,8h0l1,.25v0Zm-.73.69.69-.7-.26-.94L1.11,8l-.68.7.26.94Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "0.32 17.91 0.27 17.93 -0.24 16.67 -0.19 16.65 0.32 17.91"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M6.69,22.43h0L6.2,20.73v0l1.24-1.26,1.7.44h0l.46,1.69v0L8.39,22.86ZM9.1,20l-1.64-.42-1.18,1.2.45,1.63,1.64.42,1.18-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M3.54,25.62h0l-.38-1.35v0l1-1,1.36.35h0L5.89,25h0l-1,1Zm1.93-2L4.16,23.3l-1,1,.36,1.3,1.31.34,1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M8.18,26.1h0l-.39-1.43v0l1.06-1.07,1.43.37h0l.39,1.43h0L9.62,26.47Zm2-2.09-1.39-.36-1,1,.38,1.38,1.39.36,1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M11.29,22.92h0l-.19-.7h0l.52-.52.7.18h0l.2.69h0L12,23.1Zm1-1-.67-.17-.49.49.18.67.68.18.49-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M.53,23.93h0l-.24-.88h0l.66-.67.89.23h0l.24.88h0l-.66.67ZM1.8,22.64l-.86-.23-.62.64.23.85.86.22L2,23.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2.34,18.53h0L2.19,18h0l.37-.37.5.13h0l.14.5h0l-.36.37ZM3,17.8l-.48-.13L2.22,18l.13.48.48.12.35-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M6.23,17.71h0L6,17H6l.52-.53.71.18h0l.2.71h0l-.52.53Zm1-1-.69-.18-.5.51.19.68.69.18.5-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M9,17.92H9l-.21-.78h0l.57-.58.78.2h0l.22.77h0l-.57.58Zm1.11-1.14-.75-.19-.55.55.21.75.75.19.55-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2.66,21.77h0L2.33,20.6h0l.86-.87,1.17.3h0l.33,1.16h0l-.86.88Zm1.66-1.7-1.13-.3-.81.83.31,1.13L3.82,22l.81-.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "7.49 19.52 6.95 17.85 6.91 17.86 7.44 19.54 7.49 19.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "3.2 19.75 2.84 18.62 2.81 18.63 3.17 19.77 3.2 19.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 5.24,
    y: 22.96,
    width: 1.75,
    height: 0.05,
    transform: "translate(-14.56 11.23) rotate(-45.48)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "11.11 22.24 11.13 22.2 9.56 21.56 9.54 21.6 11.11 22.24"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 10,
    y: 23.41,
    width: 1.53,
    height: 0.05,
    transform: "translate(-13.49 14.68) rotate(-45.48)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "4.18 23.3 3.84 22.04 3.8 22.05 4.14 23.31 4.18 23.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1.61,
    y: 22.15,
    width: 1.24,
    height: 0.05,
    transform: "translate(-15.14 8.22) rotate(-45.48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M-1.08,13.83h0l-.47-1.68v0l1.25-1.27,1.69.44h0L1.85,13v0L.61,14.27Zm2.4-2.47-1.63-.43L-1.5,12.14-1,13.77l1.64.42L1.77,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M.41,17.51h0L0,16.07H0L1,15l1.44.37h0l.4,1.43v0l-1,1.07Zm2-2.1-1.38-.36-1,1,.38,1.38,1.38.36,1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M4.08,18h0l-.23-.83h0l.61-.61.82.21h0l.23.82h0l-.6.61Zm1.17-1.21-.79-.2-.58.58.22.8.8.2.57-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M3.51,14.32h0l-.19-.69h0l.51-.52.7.18h0l.19.7h0l-.51.52Zm1-1-.67-.17-.49.5.19.67.67.17L4.69,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1.2,9.32h0L1,8.55H1L1.54,8l.78.2h0l.21.78h0L2,9.52ZM2.3,8.19,1.55,8,1,8.55l.21.74.75.2.54-.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "3.33 13.65 3.35 13.61 1.78 12.96 1.76 13.01 3.33 13.65"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2.23,
    y: 14.82,
    width: 1.53,
    height: 0.05,
    transform: "translate(-9.69 6.57) rotate(-45.48)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "3.87 17.23 3.89 17.18 2.85 16.78 2.84 16.82 3.87 17.23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBannerLayer0101);
export default __webpack_public_path__ + "static/media/main_banner_layer-01-01.d24b58cc0009637038846d470becf33c.svg";
export { ForwardRef as ReactComponent };